import { render } from "./DataCollectView.vue?vue&type=template&id=1775d67a"
import script from "./DataCollectView.vue?vue&type=script&lang=js"
export * from "./DataCollectView.vue?vue&type=script&lang=js"

import "./DataCollectView.vue?vue&type=style&index=0&id=1775d67a&lang=scss"

import exportComponent from "C:\\Users\\cheew\\OneDrive\\Desktop\\CE4172\\drum\\drum-webapp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__